module.exports = __webpack_public_path__ + "static/media/transport.f0b7cab6.svg";